<style scoped lang="less">
.map-content {
  width: 100%;
  height: 260px;
}
</style>
<template>
  <div>
    <div class="page-content">
      <div class="title">位置信息</div>
      <div class="content">
        <div class="map-content">
          <baidu-map class="map-content" :center="center" :zoom="zoom">
            <bm-marker
              :position="markerPoint"
              :dragging="true"
              :icon="{url:deviceIcon,size:{width:30,height:30}}"
            ></bm-marker>
          </baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import onlineIcon from '@/assets/img/macro_online.png'; //在线icon
import offlineIcon from '@/assets/img/macro_offline.png'; //离线icon
import alertIcon from '@/assets/img/macro_alert.png'; //报警icon
// console.log('icon',onlineIcon)
export default {
  name: "positionMap",
  props: {
    markerPoint: Object,
    iconStatus:Number
  },
  data() {
    return {
      center: { lng: "", lat: "" },
      zoom: 15,
      deviceIcon:''
    };
  },
  //   props: ['noDataObj'],
  methods: {
    handler({ BMap, map }) {
      this.center.lng = this.markerPoint.lng;
      this.center.lat = this.markerPoint.lat;
      this.zoom = 15;
    },
    icon(status){
      switch (status) {
         case 0:
          return onlineIcon;
          break;
        case 1:
          return alertIcon;
          break;
        case 2:
          return offlineIcon;
          break;
      }
    }
  },
  beforeMount: function () {
    // if (this.noDataObj) {
    //   Object.assign(this.noDataInitObj, this.noDataObj);
    // }
  },
  mounted(){
    // this.deviceIcon = this.icon(this.iconStatus);

  },
  created(){
      this.deviceIcon = this.icon(this.iconStatus);

  },
  watch: {
    markerPoint: {
      handler(newName, oldName) {
        if (oldName) {
          // this.$refs.customOverlay.reload();
          this.center.lng = this.markerPoint.lng;
          this.center.lat = this.markerPoint.lat;
          this.deviceIcon = this.icon(this.iconStatus);
        }
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/positionMap.vue